<template>
    <div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.jobSubmission)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
                    <b>{{job.name}}</b>
				</md-card-content>
			</md-card>
		</div>
        <div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded && submissionList.length == 0">
            <md-card>
				<md-card-content class="text-center">
                    {{translate(locale.notApplicationAvailable)}}
				</md-card-content>
			</md-card>
        </div>

        <div class="md-layout-item md-medium-size-100 md-size-100" v-for="(submission, index) in submissionList">
            <md-card>
				<md-card-content>
                    <div class="profile-info" style="text-align: left; display: flex; align-items: center;margin-bottom: 12px;">
                        <div class="profile-name"><b>{{submission.first_name}} {{submission.last_name}}</b> ({{submission.email}})<br>{{translate(config.datelify(submission.created_date))}}</div>
                    </div>
					<div style="width: 100%; white-space: pre-wrap;">
                        <p><b>{{submission.title}}</b></p>
                        <p>{{submission.content}}</p>
                    </div>
                    <div class="attachment-container" style="display: flex;margin-top: 8px;" v-for="attachment in submission.attachment_list" v-if="attachment.url != null">
                        <a :href="'https://cdn.enterprisetechplatform.com/attachments/' + attachment.url" target="_blank"><div class="attachment">{{attachment.name}}</div></a>
                    </div>
				</md-card-content>
			</md-card>
        </div>
	</div>
</template>
<script>

	export default {
		created() {
			this.getSubmission();
			this.getJob();
		},
		data() {
			return {
				loaded: false,
                submissionList: [],
                job: {
					name: ""
				}
			}
		},
		methods: {
            getSubmission(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/profile/job/get_submission/" + this.$route.params.hash).then(data => {
					this.submissionList = data.body.data
					// console.log(data.body.data)
					this.loaded = true
				})
			},
            getJob() {
                this.$http.get(this.config.api + "/profile/job/get/" + this.$route.params.hash).then(data => {
                    let job = data.body.data.job;
                    this.job.name = job.name;
                })
            },
            
		}
	}
</script>
<style scoped>
	.attachment {
		color: #1aa348; 
		border: 1px solid #1aa348; 
		border-radius: 4px; 
		padding: 4px 8px; 
		cursor: pointer; 
		margin-right: 8px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Job/Submission.vue